// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"PageLoader_pageContainer__36YiR","loaderContainer":"PageLoader_loaderContainer__1D4mV","loaderItem":"PageLoader_loaderItem__2ahY5"};